import { useTour } from '@reactour/tour';
import { postAPI, putAPI } from 'apis/backend/apiNode';
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from 'components/bootstrap/OffCanvas';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Appel from '../../../components/Achats/Appel';
import ActivityUpdatePopup from '../../../components/Activity/ActivityUpdatePopup';
import TasksNotifications from '../../../components/Activity/TasksNotifications';
import QuestionnairePopup from '../../../components/Simulateur/QuestionnairePopup';
import Badge from '../../../components/bootstrap/Badge';
import Button from '../../../components/bootstrap/Button';
import showNotification from '../../../components/extras/showNotification';
import Icon from '../../../components/icon/Icon';
import AuthContext from '../../../contexts/authContext';
import PoseContext from '../../../contexts/poseContext';
import ThemeContext from '../../../contexts/themeContext';
import useDarkMode from '../../../hooks/useDarkMode';
import { getLangWithKey } from '../../../lang';
import { HeaderRight } from '../../../layout/Header/Header';
import { Store } from 'react-notifications-component';
import EmailSendPopup from 'pages/comptabilite/CommunComptabilite/EmailSendPopup';

const CommonHeaderRight = ({ beforeChildren, afterChildren }) => {
	const { userData, socket } = useContext(AuthContext);
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();
	const [openPlanning, setOpenPlanning] = useState(false);
	const [questionnaire, setQuestionnaire] = useState(false);
	const [tasks, setTasks] = useState(false);
	const [openAppel, setOpenAppel] = useState(false);
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};
	const [card, setCard] = useState();
	const [editModalStatus, setEditModalStatus] = useState(false);
	const [offcanvasStatus, setOffcanvasStatus] = useState(false);

	const { i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		showNotification(
			<span className='d-flex align-items-center'>
				<Icon icon={getLangWithKey(lng)?.icon} size='lg' className='me-1' />
				<span>{`Language changed to ${getLangWithKey(lng)?.text}`}</span>
			</span>,
			'You updated the language of the site. (Only "Aside" was prepared as an example.)',
		);
	};

	/**
	 * Language attribute
	 */
	useLayoutEffect(() => {
		document.documentElement.setAttribute('lang', i18n.language);
	});
	const { pose, setPose } = useContext(PoseContext);

	const { setIsOpen } = useTour();
	const [missedCalls, setmissedCalls] = useState(0);
	const [lateTasks, setLateTasks] = useState(0);
	const [createtModalStatus, setCreatetModalStatus] = useState(false);
	const [activeAlert, setActiveAlert] = useState(null);
	const [notifications, setNotifications] = useState([]);
	const [unreadNotifs, setUnreadNotifs] = useState(0); // Badge pour les infos
	const [infoNotifications, setInfoNotifications] = useState([]); // Liste des notifs info
	const [offcanvasNotifStatus, setOffcanvasNotifStatus] = useState(false);

	useEffect(() => {
		if (!socket) return;

		// 1. Gestion des Rappels (Tâches)
		socket.on("latetasks", (data) => {
			console.log("📥 Late tasks updated:", data);
			setLateTasks(data); // Met à jour votre état global/local
		});
		// 2. Gestion des Notifications Info (Le flux système)
		socket.on("notifications", (data) => {
			// Supposons que le serveur envoie la liste des notifs non lues
			setInfoNotifications(data);
			setUnreadNotifs(data.filter(n => !n.isRead).length);
		});
		// 3. Ton alerte instantanée (Toasts) reste la même
		socket.on("rappelAlert", (data) => {
			console.log("🔔 New Rappel Alert:", data);

			// Jouer le son
			const audio = new Audio(require('../../../assets/Chocolate_Notification_Tone.mp3'));
			audio.volume = 0.2; // 0.0 → 1.0
			audio.play().catch(e => { });

			// AJOUTER à la liste existante au lieu de remplacer
			setNotifications((prev) => {
				// Optionnel : éviter les doublons si le socket renvoie la même ID
				const exists = prev.find(n => (n.id || n._id) === (data.id || data._id));
				if (exists) return prev;
				return [...prev, data];
			});
		});

		// 🚨 MISSED CALL ALERT
		socket.on("missedCallAlert", (data) => {
			console.log("📞 Missed Call Alert:", data);

			const audio = new Audio(
				"https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3"
			);
			audio.volume = 0.2; // 0.0 → 1.0
			audio.play().catch(() => { });

			setNotifications((prev) => {
				const exists = prev.find(
					n => (n.id || n._id) === (data.id || data._id)
				);

				if (exists) return prev;

				return [
					{
						...data,
						type: "MISSED_CALL"
					},
					...prev
				];
			});
		});


		return () => {
			socket.off("latetasks");
			socket.off("notifications");
			socket.off("rappelAlert");
			socket.off("missedCallAlert");

		};
	}, [socket]);

	const closeNotification = (id) => {
		setNotifications((prev) => prev.filter(n => (n.id || n._id) !== id));
	};

	const handleAlertComplete = async (id) => {
		await putAPI('rappel', { state: 'completed' }, `/${id}`);
		socket.emit("updateRappel"); // Synchro badge/offcanvas
		closeNotification(id); // Retire de la pile
	};

	const handleAlertSnooze = async (id) => {
		const newTime = moment().add(15, 'minutes').toISOString();
		await putAPI('rappel', { state: 'pending', datetime: newTime }, `/${id}`);
		socket.emit("updateRappel"); // Synchro badge/offcanvas
		closeNotification(id); // Retire de la pile
	};
	return (
		<>

			{/* Conteneur de notifications en bas à droite */}
			<div
				className="position-fixed  end-0 p-3"
				style={{
					zIndex: 2000,
					display: 'flex',
					flexDirection: 'column-reverse', // Le plus récent en bas
					// gap: '10px',
					pointerEvents: 'none' // Permet de cliquer à travers le conteneur vide
				}}
			>
				{notifications.map((notif) => (
					<div key={notif.id || notif._id} style={{ pointerEvents: 'auto' }}>
						<NotificationToast
							data={notif}
							onComplete={handleAlertComplete}
							onSnooze={handleAlertSnooze}
							onClose={() => closeNotification(notif.id || notif._id)}
						/>
					</div>
				))}
			</div>
			<div className='row g-3 '>

				{beforeChildren}


				{/* --- ICÔNE 1 : RAPPELS / TÂCHES --- */}
				<div className='col-auto mt-4'>
					<Button
						{...styledBtn}
						icon='Alarm' // Utilise une icône d'alarme pour les tâches
						color='primary'
						onClick={() => setOffcanvasStatus(true)}>
					</Button>
					<div className='position-relative animate__animated animate__headShake animate__infinite animate__slower' style={{ top: '-44px', right: '-28px' }}>
						<Badge rounded={'circle'} color='danger'>
							{!!lateTasks?.length && lateTasks?.filter(task => task.state === 'pending' && new Date(task.datetime) < new Date()).length || ''}
						</Badge>
					</div>
				</div>

				{/* --- ICÔNE 2 : NOTIFICATIONS SYSTÈME (Infos) --- */}
				<div className='col-auto mt-4'>
					<Button
						{...styledBtn}
						icon='Notifications' // Icône info ou notifications classique
						color='info'
						onClick={() => setOffcanvasNotifStatus(true)}>
					</Button>
					<div className='position-relative' style={{ top: '-44px', right: '-28px' }}>
						{/* Badge pour les notifications non lues */}
						{infoNotifications?.length > 0 && (
							<Badge rounded={'circle'} color='warning'>
								{infoNotifications?.length}
							</Badge>
						)}
					</div>
				</div>

				{offcanvasStatus && <TasksNotifications setOffcanvasStatus={setOffcanvasStatus} lateTasks={lateTasks} />}
				{offcanvasNotifStatus && (
					<InfoNotifications
						setOffcanvasStatus={setOffcanvasNotifStatus}
						notifications={infoNotifications}
						setNotifications={setInfoNotifications}
					/>
				)}


				{(userData?.role?.toLowerCase() == 'gestionnaire' ||
					userData?.role?.toLowerCase().includes('admin')) && (
						<>
							{/* <div className='col-auto mt-4'>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								style={{
									color: darkModeStatus ? 'dark' : 'light',
									hoverShadow: 'default',
									isLight: !darkModeStatus,
								}}
								{...styledBtn}
								className='btn-only-icon'
								isLight
								icon={'ContactSupport'}
								color='info'
								onClick={() => setQuestionnaire(true)}
							/>
						</div> */}
							{!!questionnaire && <QuestionnairePopup setOpenPopup={setQuestionnaire} />}
							{/* <div className='col-auto mt-4'>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								style={{
									color: darkModeStatus ? 'dark' : 'light',
									hoverShadow: 'default',
									isLight: !darkModeStatus,
								}}
								{...styledBtn}
								isLight
								icon={'Today'}
								color='primary'
								onClick={() => setOpenPlanning(true)}></Button>
							{openPlanning && <PlanifierPlanning setOpenPopup={setOpenPlanning} />}
						</div> */}
							{/* <div className='col-auto mt-4'>
							<Button
								// eslint-disable-next-line react/jsx-props-no-spreading
								{...styledBtn}
								style={{
									color: darkModeStatus ? 'dark' : 'light',
									hoverShadow: 'default',
									isLight: !darkModeStatus,
								}}
								isLight
								icon={'call'}
								color='success'
								onClick={() => setOpenAppel(true)}></Button>
						</div> */}
							{!!openAppel && <Appel setOpenAppel={setOpenAppel} />}
							{/* <div className='col-auto mt-4'>
								<Button

									{...styledBtn}
									isLight
									icon={'PhoneMissed'}
									color='danger'
									onClick={handleOnClickToCallHistoryPage}
									className='btn-only-icon'></Button>
								
								<div
									className={classNames(
										'position-relative',
										'animate__animated animate__infinite animate__slower',
									)}
									style={{ top: '-44px', right: '-28px' }}>
									<Badge rounded={'circle'} color='danger'>
										{missedCalls}
									</Badge>
								</div>

							
							</div> */}
							{/* <ChatHeaderIcon /> */}

						</>
					)}

				{/* <div className='col-auto mt-4'>
					<Popovers trigger='hover' desc='Dark / Light mode'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							onClick={() => setDarkModeStatus(!darkModeStatus)}
							className='btn-only-icon'
							data-tour='dark-mode'>
							<Icon
								icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
								color={darkModeStatus ? 'info' : 'warning'}
								className='btn-icon'
							/>
						</Button>
					</Popovers>
				</div> */}

				{/* <NotificationHeaderIcon /> */}

				{/* {(userData?.role?.toLowerCase() == 'gestionnaire' ||
					userData?.role?.toLowerCase().includes('admin')) && (
						<>
							<div className='col-auto position-relative mt-4'>
								<Button
									{...styledBtn}
									icon='Notifications'
									onClick={() => setOffcanvasStatus(true)}
									aria-label='Notifications'
								/>

								{lateTasks?.length > 0 && (
									<Icon
										icon='Circle'
										className={classNames(
											'position-absolute start-65',
											'text-danger',
											'animate__animated animate__heartBeat animate__infinite animate__slower',
										)}
									/>
								)}
							</div>
						</>

					)} */}

				{/* 
				<div className='col d-flex align-items-center cursor-pointer'>
					<div className='me-3'>
						<div className='text-end'>
							<div className='fw-bold fs-6 mb-0'>
								{`${userData?.name} ${userData?.surname}`}
							</div>
							<div className='text-muted'>
								<small>{userData?.position}</small>
							</div>
						</div>
					</div>
					<div className='position-relative'>
						<Avatar
							srcSet={userData?.srcSet}
							src={userData?.src}
							size={48}
							color={userData?.color}
							style={{ objectFit: 'cover', objectPosition: 'top' }}
						/>

						<span className='position-absolute top-85 start-85 translate-middle badge border border-2 border-light rounded-circle bg-success p-2'>
							<span className='visually-hidden'>Online user</span>
						</span>
					</div>
				</div> */}

				{/*	Full Screen */}
				{/* <div className='col-auto'>
					<Popovers trigger='hover' desc='Fullscreen'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
							onClick={() => setFullScreenStatus(!fullScreenStatus)}
							aria-label='Toggle dark mode'
						/>
					</Popovers>
				</div> */}

				{/* Lang Selector */}
				{/* <div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							{typeof getLangWithKey(i18n.language as ILang['key']['lng'])?.icon ===
							'undefined' ? (
								<Button
									// eslint-disable-next-line react/jsx-props-no-spreading
									{...styledBtn}
									className='btn-only-icon'
									aria-label='Change language'
									data-tour='lang-selector'>
									<Spinner isSmall inButton='onlyIcon' isGrow />
								</Button>
							) : (
								<Button
									// eslint-disable-next-line react/jsx-props-no-spreading
									{...styledBtn}
									icon={
										getLangWithKey(i18n.language as ILang['key']['lng'])?.icon
									}
									aria-label='Change language'
									data-tour='lang-selector'
								/>
							)}
						</DropdownToggle>
						<DropdownMenu isAlignmentEnd data-tour='lang-selector-menu'>
							{Object.keys(LANG).map((i) => (
								<DropdownItem key={LANG[i].lng}>
									<Button
										icon={LANG[i].icon}
										onClick={() => changeLanguage(LANG[i].lng)}>
										{LANG[i].text}
									</Button>
								</DropdownItem>
							))}
						</DropdownMenu>
					</Dropdown>
				</div> */}

				{/* Quick Panel */}
				{/* <div className='col-auto'>
					<Dropdown>
						<DropdownToggle hasIcon={false}>
							<Button {...styledBtn} icon='Tune' aria-label='Quick menu' />
						</DropdownToggle>
						<DropdownMenu isAlignmentEnd size='lg' className='py-0 overflow-hidden'>
							<div className='row g-0'>
								<div
									className={classNames(
										'col-12',
										'p-4',
										'd-flex justify-content-center',
										'fw-bold fs-5',
										'text-info',
										'border-bottom border-info',
										{
											'bg-l25-info': !darkModeStatus,
											'bg-lo25-info': darkModeStatus,
										},
									)}>
									Quick Panel
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-end border-bottom',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Public' size='3x' color='info' />
										<span>Dealers</span>
										<small className='text-muted'>Options</small>
									</div>
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-bottom',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Upcoming' size='3x' color='success' />
										<span>Inbox</span>
										<small className='text-muted'>Configuration</small>
									</div>
								</div>
								<div
									className={classNames(
										'col-6 p-4 transition-base cursor-pointer bg-light-hover',
										'border-end',
										{ 'border-dark': darkModeStatus },
									)}>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='Print' size='3x' color='danger' />
										<span>Print</span>
										<small className='text-muted'>Settings</small>
									</div>
								</div>
								<div className='col-6 p-4 transition-base cursor-pointer bg-light-hover'>
									<div className='d-flex flex-column align-items-center justify-content-center'>
										<Icon icon='ElectricalServices' size='3x' color='warning' />
										<span>Power</span>
										<small className='text-muted'>Mode</small>
									</div>
								</div>
							</div>
						</DropdownMenu>
					</Dropdown>
				</div> */}

				{afterChildren}
			</div>


			{editModalStatus && (
				<ActivityUpdatePopup card={card} setEditModalStatus={setEditModalStatus} />
			)}

		</>
	);
};


CommonHeaderRight.propTypes = {
	beforeChildren: PropTypes.node,
	afterChildren: PropTypes.node,
};
CommonHeaderRight.defaultProps = {
	beforeChildren: null,
	afterChildren: null,
};

const DevisPaiementTable = ({ message }) => {
	const [loading, setLoading] = useState(true);
	const [devisList, setDevisList] = useState([]);
	const [paidRefs, setPaidRefs] = useState([]);

	useEffect(() => {
		const parseMessage = (msg) => {
			const lines = msg?.split("\n") || [];
			const devis = [];

			for (const line of lines) {
				if (
					line.includes("|") &&
					!line.startsWith("Référence") &&
					!line.startsWith("─") &&
					!line.startsWith("═") &&
					!line.trim().startsWith("📋") &&
					!line.trim().startsWith("💰")
				) {
					const parts = line.split("|").map((s) => s.trim());

					// ref | date | restant
					if (parts.length >= 3) {
						devis.push({
							ref: parts[0],
							date: parts[1],
							restant: parts[2]
						});
					}
				}
			}

			return devis;
		};

		const fetchStatus = async (parsed) => {
			try {
				const allRefs = parsed.map((d) => d.ref);

				if (!allRefs.length) return;

				const response = await postAPI(
					"devis",
					{ references: allRefs },
					"/check-devis-paiement-status"
				);

				if (response?.paidToday) {
					setPaidRefs(response.paidToday);
				}
			} catch (err) {
				console.error("Erreur sync paiements:", err);
			}
		};

		const parsed = parseMessage(message);

		setDevisList(parsed);

		fetchStatus(parsed).finally(() => setLoading(false));
	}, [message]);

	if (loading)
		return (
			<div className="text-center p-2">
				<Spinner size="sm" color="primary" />
			</div>
		);

	if (!devisList.length) return null;

	return (
		<div className="mt-2">
			<div className="table-responsive">
				<table
					className="table table-sm table-bordered text-nowrap mb-0"
					style={{ fontSize: "11px" }}
				>
					<thead className="bg-light text-uppercase">
						<tr>
							<th>Référence</th>
							<th>Accepté le</th>
							<th>Reste</th>
						</tr>
					</thead>

					<tbody>
						{devisList.map((d, idx) => {
							const isPaid = paidRefs.includes(d.ref);
							const isUnpaid = parseFloat(d.restant) > 0;

							return (
								<tr
									key={idx}
									className={
										isPaid
											? "table-light"
											: isUnpaid
												? "table-warning"
												: "table-success"
									}
								>
									<td
										className={`fw-bold text-primary ${isPaid
											? "text-decoration-line-through text-muted"
											: ""
											}`}
									>
										{d.ref}
									</td>

									<td
										className={
											isPaid
												? "text-decoration-line-through text-muted"
												: ""
										}
									>
										{moment(d.date).format("DD/MM/YYYY")}
									</td>

									<td
										className={
											isPaid
												? "text-decoration-line-through text-muted"
												: isUnpaid
													? "text-danger fw-bold"
													: "text-success fw-bold"
										}
									>
										{d.restant}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

const InterventionsRetaperTable = ({ notif }) => {
	const [haveDevisIds, setHaveDevisIds] = useState([]);
	const [loading, setLoading] = useState(true);
	const interventions = notif?.data?.interventions || [];

	useEffect(() => {
		if (!interventions.length) {
			setLoading(false);
			return;
		}

		const ids = interventions.map(inv => inv.id);
		const fetchDevisStatus = async () => {
			try {
				const response = await postAPI("planning", { interventionIds: ids }, "/intervention/check-interventions-devis-status");
				if (response && response.haveDevis) {
					setHaveDevisIds(response.haveDevis);
				}
			} catch (err) {
				console.error("Erreur vérification devis pour retaper:", err);
			} finally {
				setLoading(false);
			}
		};

		fetchDevisStatus();
	}, [interventions]);

	if (loading) return <div className="text-center p-2"><Spinner size="sm" color="primary" /></div>;
	if (interventions.length === 0) return null;

	return (
		<div className="mt-2">
			<div className="table-responsive">
				<table className="table table-sm table-bordered text-nowrap mb-0" style={{ fontSize: '11px' }}>
					<thead className="bg-light text-uppercase">
						<tr>
							<th>Référence</th>
							<th>Créé le</th>
						</tr>
					</thead>
					<tbody>
						{interventions.map((inv, idx) => {
							const hasDevis = haveDevisIds.includes(inv.id);
							return (
								<tr key={idx} className={hasDevis ? "table-light" : ""}>
									<td className={`fw-bold ${hasDevis ? 'text-decoration-line-through text-muted' : 'text-primary'}`}>
										{inv.reference}
									</td>
									<td className={hasDevis ? 'text-decoration-line-through text-muted' : ''}>
										{inv.date_debut ? moment(inv.date_debut).fromNow() : "date inconnue"}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

const DevisRelanceTable = ({ message }) => {
	const [checkedRefs, setCheckedRefs] = useState([]);
	const [loading, setLoading] = useState(true);
	const [devisList, setDevisList] = useState([]);

	const [openEmail, setOpenEmail] = useState(false);
	const [selectedDevisId, setSelectedDevisId] = useState(null);

	console.log("selectedDevisId", selectedDevisId)
	useEffect(() => {
		const parseMessage = (msg) => {
			const lines = msg.split('\n');
			const devis = [];
			for (const line of lines) {
				if (line.includes('|') && !line.startsWith('Réf') && !line.startsWith('---') && !line.startsWith('══') && !line.startsWith('──')) {
					const parts = line.split('|').map(s => s.trim());
					if (parts.length >= 2) {
						const _id = parts[0];
						const ref = parts[1];
						const status = parts[2];
						devis.push({ _id, ref, status });
					}
				}
			}
			return devis;
		};

		const parsed = parseMessage(message);
		setDevisList(parsed);

		const fetchStatus = async () => {
			try {
				const allRefs = parsed.map(d => d.ref);
				if (allRefs.length === 0) {
					setLoading(false);
					return;
				}
				const response = await postAPI("devis", { references: allRefs }, "/check-relances-status");
				if (response && response.relancedToday) {
					setCheckedRefs(response.relancedToday);
				}
			} catch (err) {
				console.error("Erreur sync relances:", err);
			} finally {
				setLoading(false);
			}
		};

		fetchStatus();
	}, [message]);
	console.log("checkedRefs",checkedRefs)
	if (loading) return <div className="text-center p-2"><Spinner size="sm" color="primary" /></div>;

	return (
		<div className="mt-2">
			<div className="table-responsive">
				<table className="table table-sm table-bordered text-nowrap mb-0" style={{ fontSize: '11px' }}>
					<thead className="bg-light text-uppercase">
						<tr>
							<th>Référence</th>
							<th>Statut</th>
						</tr>
					</thead>
					<tbody>
						{devisList.map((devis, idx) => {
							const isDone = checkedRefs.includes(devis.ref);
							const isCreated = devis.status.toLowerCase().startsWith('créé');
							return (
								<tr
									key={idx}
									className={isDone ? "table-light" : ""}
									style={isCreated && !isDone ? { backgroundColor: '#f8d7da' } : {}}
								>
									<td className={`fw-bold ${isDone ? 'text-decoration-line-through text-muted' : 'text-primary'}`}>
										{devis.ref}
									</td>
									<td className={isDone ? 'text-decoration-line-through text-muted' : ''}>
										{isDone ? "Terminé" : devis.status}
									</td>
									<td className="text-center">
										<Button
											size="sm"
											icon='send'
											color="primary"
											disabled={isDone}
											onClick={() => {
												setSelectedDevisId(devis._id);
												setOpenEmail(true);
											}}
										>
										</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{openEmail && (
				<EmailSendPopup
					isOpen={openEmail}
					setIsOpen={setOpenEmail}
					model="Devis"
					recordId={selectedDevisId}
					EmailType="relance"
					fnSuccess={async () => {
						setCheckedRefs((prev) => [
							...prev,
							devisList.find((d) => d._id === selectedDevisId)?.ref,
						]);
						await putAPI(
							'devis',
							{ remarques: "Relance automatique par mail" },
							`/${selectedDevisId}/relancer`
						);
						setOpenEmail(false);
					}}
				/>
			)}
		</div>
	);
};

const renderMessage = (notif) => {
	if (notif.type === "DEVIS_A_RELANCER") {
		return <DevisRelanceTable message={notif.message} />;
	}

	if (notif.type === "INTERVENTION_SANS_DEVIS") {
		return <InterventionsRetaperTable notif={notif} />;
	}

	if (notif.type === "DEVIS_PAIEMENT_NON_ATTACHE") {
		return <DevisPaiementTable message={notif.message} />;
	}

	return <span className="small text-muted">{notif.message}</span>;
};

const InfoNotifications = ({ setOffcanvasStatus, notifications, setNotifications }) => {
	return (
		<OffCanvas placement='end' isOpen={true} setOpen={() => { }}>
			<OffCanvasHeader setOpen={setOffcanvasStatus}>
				<OffCanvasTitle>Notifications Système</OffCanvasTitle>
			</OffCanvasHeader>
			<OffCanvasBody className="bg-light-subtle">
				<div className="list-group list-group-flush">
					{notifications.length === 0 ? (
						<div className="text-center p-5 text-muted">
							<i className="ri-notification-off-line ri-2x mb-2 d-block"></i>
							Aucune notification
						</div>
					) : (
						notifications.map((n) => (
							<div
								key={n._id}
								className="list-group-item px-3 pb-3 pt-4 border-bottom bg-white mb-2 shadow-sm rounded position-relative"
							>
								{/* bouton close */}

								<Icon icon='close' onClick={async () => {
									await putAPI("rappel", {}, `/notification/${n._id}/read`);

									// remove local state (optimistic UI)
									setNotifications((prev) =>
										prev.filter((item) => item._id !== n._id)
									);
								}}
									className="position-absolute top-0 end-0 m-2 cursor-pointer"
								/>


								<div className="d-flex justify-content-between align-items-center mb-2">
									<div className="d-flex align-items-center">
										<div className="avatar-xs me-2">
											<span className="avatar-title bg-info-subtle text-info rounded-circle fs-6">
												<i className="ri-error-warning-line"></i>
											</span>
										</div>
										<small className="fw-bold text-dark">
											{n.title || 'Information'}
										</small>
									</div>

									<small className="text-muted">
										{moment(n.createdAt).fromNow()}
									</small>
								</div>

								{renderMessage(n)}
							</div>
						))
					)}
				</div>
			</OffCanvasBody>
		</OffCanvas>
	);
};

const NotificationToast = ({ data, onComplete, onSnooze, onClose }) => {
	const isSystemInfo = data.type === "INFO"; // Vérifie si c'est une notification info
	const isMissedCall = data.type === "MISSED_CALL";


	// Logique de temps uniquement pour les rappels
	const taskTime = new Date(data.datetime).getTime();
	const now = new Date().getTime();
	const diffInMinutes = (now - taskTime) / (1000 * 60);

	let status;

	// 🚨 MISSED CALL



	// ℹ️ SYSTEM INFO
	if (isSystemInfo) {
		// Configuration pour les notifications d'information
		status = {
			title: data.title || "Notification Système",
			color: "info",
			icon: "Info",
			animate: "animate__animated animate__fadeIn"
		};
	} else if (isMissedCall) {
		status = {
			title: "🚨 APPEL MANQUÉ URGENT",
			color: "danger",
			icon: "CallMissed",
			animate: "animate__animated animate__headShake animate__infinite"
		};
	} else {
		// Configuration pour les rappels (Urgent ou Retard)
		if (diffInMinutes >= 0 && diffInMinutes <= 1) {
			status = {
				title: "Rappel Urgent !",
				color: "danger",
				icon: "NotificationsActive",
				animate: ""
			};
		} else {
			status = {
				title: "Tâche en retard",
				color: "warning",
				icon: "History",
				animate: ""
			};
		}
	}

	return (
		<div
			className={`card shadow-lg border-start border-${status.color} border-5 ${status.animate}`}
			style={{ width: '350px', backgroundColor: isMissedCall ? "#fff5f5" : "#fff" }}
		>
			<div className="card-body">
				<div className="d-flex align-items-center mb-2">
					<div className="flex-shrink-0">
						<Icon
							icon={status.icon}
							color={status.color}
							size="lg"
							className={!isSystemInfo ? "animate__animated animate__swing animate__infinite animate__slower" : ""}
						/>
					</div>
					<div className="flex-grow-1 ms-3">
						<h6 className={`mb-0 fw-bold text-${status.color}`}>
							{status.title}
						</h6>
					</div>
					<button type="button" className="btn-close" onClick={onClose}></button>
				</div>

				<p
					className={`card-text mb-2 fw-bold ${isMissedCall ? "text-danger" : "text-dark"
						}`}
				>{data.note}</p>

				{/* On n'affiche le créateur et l'heure QUE pour les rappels */}
				{!isSystemInfo && !isMissedCall && (
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span className="text-muted small">Par: {data.createdBy}</span>
						<span className="badge bg-light text-dark border">
							{moment(data.datetime).format('HH:mm')}
						</span>
					</div>
				)}

				{/* MISSED CALL BADGE */}
				{isMissedCall && (
					<div className="mb-3 text-center">
						<span className="badge bg-danger fs-6 px-3 py-2 animate__animated animate__flash animate__infinite">
							Appel manqué
						</span>
					</div>
				)}
				{/* Texte de rappel récurrent uniquement pour les rappels */}
				{!isSystemInfo && !isMissedCall && (
					<div className="text-center mb-3">
						<small className="text-muted" style={{ fontSize: '0.75rem' }}>
							<Icon icon="Info" size="sm" className="me-1" />
							Cette alerte réapparaîtra chaque minute jusqu'à action.
						</small>
					</div>
				)}

				<div className="d-flex gap-2">
					{isSystemInfo ? (
						// BOUTON UNIQUE POUR INFO
						<Button
							color="info"
							className="flex-grow-1"
							size="sm"
							onClick={onClose} // On ferme simplement
						>
							Compris
						</Button>
					) : isMissedCall ? (
						/* MISSED CALL */
						<Button
							color="danger"
							className="flex-grow-1 fw-bold"
							size="sm"
							onClick={onClose}
						>Fermer
						</Button>
					) : (
						// BOUTONS STANDARDS POUR TÂCHES
						<>
							<Button
								color="success"
								className="flex-grow-1"
								size="sm"
								onClick={() => onComplete(data.id || data._id)}
							>
								Terminer
							</Button>
							<Button
								color="warning"
								className="flex-grow-1"
								size="sm"
								onClick={() => onSnooze(data.id || data._id)}
							>
								+15 min
							</Button>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default CommonHeaderRight;
